/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import isEmpty from 'lodash/isEmpty';
import uniq from 'lodash/uniq';
import PropTypes from 'prop-types';
import { Button, Icon } from 'sarsaparilla';
import { errorsToStringList } from '../../src/utils/utilsNew';

const propTypes = {
    errorHeader: PropTypes.string,
    errors: PropTypes.arrayOf(
        PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.shape({
                error: PropTypes.string,
            }),
        ])
    ),
    isInline: PropTypes.bool,
    clear: PropTypes.func,
    className: PropTypes.string,
};

export default function ErrorNotification({
    errorHeader,
    errors,
    isInline,
    clear,
    className,
}) {
    const renderErrors = () => {
        const errorsList = uniq(errorsToStringList(errors));
        const header = errorHeader || 'Errors:';

        if (!isEmpty(errorsList)) {
            return (
                <div className={className}>
                    <div className="rec-notification-error permit-error-notification">
                        <span className="rec-notification-icon">
                            <Icon iconName="error" />
                        </span>
                        {errorsList.length === 1 ? (
                            <div className="rec-notification-body">
                                <div
                                    className={
                                        isInline
                                            ? 'rec-notification-title-single-row'
                                            : 'rec-notification-title'
                                    }
                                >
                                    {header}
                                </div>
                                <p>{errorsList[0]}</p>
                            </div>
                        ) : (
                            <div className="rec-notification-body">
                                <div className="rec-notification-title" id="header">
                                    {header}
                                </div>
                                <ul>
                                    {errorsList.map((err) => (
                                        <li key={err}>{err}</li>
                                    ))}
                                </ul>
                            </div>
                        )}
                        {!!clear && (
                            <Button
                                appearance="subtle"
                                size="sm"
                                iconBeforeElement={<Icon iconName="close" />}
                                screenReaderTextBefore="Close the error notification"
                                onClick={clear}
                                className="rec-notification-close"
                            />
                        )}
                    </div>
                </div>
            );
        }

        return null;
    };

    // If errors array is undefined, or every element in errors array is undefined
    if (!errors || errors.every((elem) => elem === undefined)) {
        return null;
    }

    return <div className="permit-notifications-errs">{renderErrors()}</div>;
}

ErrorNotification.propTypes = propTypes;
